import { useRouter } from "next/router"
import { useAppDispatch } from "../../../../state/store"
import { goToCheckout } from "../../state/actions/goToCheckout"
import { goToRecommendations } from "../../state/actions/goToRecommendations"

export const useCheckoutNavigation = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const navigateToCheckout = async () => dispatch(goToCheckout(router))
  const navigateToRecommendations = async () =>
    dispatch(goToRecommendations(router))

  return {
    navigateToCheckout,
    navigateToRecommendations,
  }
}
